module.exports = __webpack_public_path__ + "static/img/beta_bg_white_04.6cf56476.svg";